export const recommendationArmColor = (color: string, random: number) => {

    var recommendationColors: any = {
        "mint-julep": [
            "slate-grey",
            "sepia-brown",
            "white"
        ],
        "recycled-money": [
            "slate-grey",
            "sepia-brown",
            "white"
        ],
        "denim-blue": [
            "white",
            "daffodil-yellow",
            "dark-chocolate"
        ],
        "olive-oil": [
            "sepia-brown",
            "white",
            "tangerine"
        ],
        "oat-milk": [
            "dark-chocolate",
            "forest-green",
            "raspberry-cordial"
        ],
        "gingerbread": [
            "oat-milk",
            "daffodil-yellow",
            "clear-frost"
        ],
        "black": [
            "white",
            "royal-purple",
            "sky-blue"
        ],
        "clear-frost": [
            "forest-green",
            "midnight-blue"
        ],
        "daffodil-yellow": [
            "denim-blue",
            "raspberry-cordial",
            "olive-oil"
        ],
        "power-pink": [
            "black",
            "white",
            "sky-blue"
        ],
        "raspberry-cordial": [
            "oat-milk",
            "daffodil-yellow",
            "clear-frost"
        ],
        "forest-green": [
            "oat-milk",
            "clear-frost",
            "sepia-brown"
        ],
        "dark-chocolate": [
            "oat-milk",
            "tangerine",
            "sky-blue"
        ],
        "royal-purple": [
            "white",
            "power-pink",
            "clear-frost"
        ],
        "tangerine": [
            "white",
            "dark-chocolate",
            "denim-blue"
        ],
        "pink-lemonade": [
            "white",
            "sky-blue",
            "forest-green"
        ],
        "sky-blue": [
            "white",
            "power-pink",
            "tangerine"
        ],
        "slate-grey": [
            "white",
            "azure-blue",
            "raspberry-cordial"
        ],
        "pistachio": [
            "oat-milk",
            "denim-blue",
            "clear-frost"
        ],
        "white": [
            "black",
            "royal-purple",
            "forest-green"
        ],
        "sepia-brown": [
            "white",
            "forest-green",
            "olive-oil"
        ],
        "midnight-blue": [
            "clear-frost",
            "power-pink",
            "tangerine"
        ],
        "azure-blue": [
            "white",
            "slate-grey",
            "tangerine"
        ],
        "koala-grey": [
            "slate-grey",
            "sepia-brown",
            "white"
        ],
        "beeswax": [
            "slate-grey",
            "sepia-brown",
            "white"
        ],
    };

    // eslint-disable-next-line no-prototype-builtins
    if (!recommendationColors.hasOwnProperty(color)) {
        const allColors = Object.values(recommendationColors).flat();
        return allColors[Math.floor(random * allColors.length)];
    }

    return recommendationColors[color][Math.floor(random * recommendationColors[color].length)];
}